<template>
  <div class="form-item-country-wrapper">
    <div class="form-item-input-wrapper">
      <!-- area-code -->
      <div class="area-code-wrapper" @touchstart="handleInputFocus" @click="handleInputFocus">
        <div class="area-code-wrap">
          <label for="area-code" class="form-item-label">{{ i18n.t('country') }}</label>
          <div
            id="area-code"
            class="area-code-input-wrapper"
            ref="area-code-input-wrapper"
            @click="toggleAreaList"
            v-clickOutside="popoverOutsideClick"
          >
            <span class="">{{ countryName }}</span>
            <img src="~img/icon-arrow-down.svg" alt="img-open" />
          </div>
        </div>
      </div>
      <!-- 下拉展示部分 -->
      <transition name="fade">
        <div class="area-code-popover" ref="" v-show="showAreaCodePopover">
          <div class="area-code-popover-content">
            <div class="search-input-wrapper">
              <input
                id="area-code"
                type="text"
                class="search-input aaa"
                autocomplete="off"
                v-model="searchText"
                data-search-type="search"
              />
              <img class="icon-search" src="~img/search-Icon.png" alt="search area code" />
            </div>
            <div class="area-code-list-wrapper">
              <ul class="area-code-list" role="listbox">
                <li
                  role="option"
                  v-for="(ctr, index) in showList"
                  class="area-code-item"
                  :data-index="index"
                  :key="`${index}-${ctr.telabbr}`"
                  @click="areaItemClick(ctr)"
                >
                  <span class="area-name">{{ ctr.name }}</span
                  >&nbsp;
                  <span class="area-code">(+{{ ctr.telabbr }})</span>
                </li>
                <li role="option" class="search-no-results" v-show="showList.length === 0">
                  {{ i18n.t('search-box-no-found') }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="slot-wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
  import { clickOutside } from '@/utils/directive.js';
  import i18n from '@/i18n';

  export default {
    data() {
      return {
        i18n,
        list: [],
        searchText: '',
        showAreaCodePopover: false,
        countryName: 'Canada',
        countryId: '100111',
      };
    },

    props: {
      dialCode: {
        type: String,
        default: '1',
      },

      areaList: {
        type: Array,
        default: () => [],
      },
    },

    mounted() {
      // TODO: 首次执行时，设置一个默认值
      this.$emit('value', { country: this.countryId }, 'country');
    },

    methods: {
      toggleAreaList() {
        this.showAreaCodePopover = !this.showAreaCodePopover;
      },

      areaItemClick(ctr) {
        this.showAreaCodePopover = false;
        this.countryName = ctr.name;

        this.$emit('update:dialCode', ctr.telabbr);
        this.$emit('value', { country: ctr.id }, 'country');
      },

      popoverOutsideClick(e) {
        if (e.target.className.includes('search-input')) return;
        this.showAreaCodePopover && (this.showAreaCodePopover = false);
      },

      handleInputFocus() {
        this.inputReadonly = false;
      },
    },

    computed: {
      showList() {
        let searchText = this.searchText || '';
        let data = this.areaList.filter(ctr => ctr.name && ctr.telabbr && ctr.code);
        if (searchText.length === 0) {
          return data;
        }
        searchText = searchText.replace('+', '\\+');
        data = data.filter(ctr => {
          const reg = new RegExp(searchText, 'gi');
          const nameFlag = reg.test(ctr.name);
          const dialCodeFlag = reg.test(ctr.telabbr);
          const iso2Flag = reg.test(ctr.ios2);
          return nameFlag || dialCodeFlag || iso2Flag;
        });
        return data;
      },
    },

    directives: { clickOutside },

    watch: {
      showAreaCodePopover(newVal) {
        if (!newVal) {
          this.searchText = '';
        }
      },
    },
  };
</script>

<style lang="scss">
  @import './index';
  @import './mobile';
</style>
